<template>
  <div v-if="can('list-registered-device')">
    <h2 class="">Device List</h2>
    <div class="list-table">
      <div class="col-md-12">
        <div class="block-right col-md-2">
          <div class="btn-group float-right" style="margin-bottom: 5px">
            <input
              type="text"
              class="float-right form-control"
              style="margin: 0px"
              placeholder="Search"
              v-model="query"
              v-on:keyup.enter="searchDevice()"
            />
            <span
              class="fa fa-search btn btn-success"
              style="cursor: pointer"
              v-on:click="searchDevice()"
            />
          </div>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col">ID</th>
            <th scope="col">OS</th>
            <th scope="col">Sort</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="data in deviceList" :key="data.id">
            <td>{{ data.device_name }}</td>
            <td>{{ data.device_id }}</td>
            <td>{{ data.os_type }}</td>
            <td>{{ data.sort }}</td>
            <td v-html="statusHtml(data.status)"></td>

            <td>
              <router-link
                v-if="can('edit-registered-device')"
                class=""
                :to="{
                  name: 'EditDevice',
                  params: {
                    id: data.id,
                  },
                }"
                ><i class="fa fa-edit text-warning" title="Edit"></i
              ></router-link>
              <i
                style="cursor: pointer"
                title="Delete"
                class="fa ps-3 fa-trash text-danger"
                v-if="can('delete-registered-device')"
                v-on:click="deleteDevice(data.id)"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-md-6">
          <select class="form-control" v-model="currentPage">
            <option v-for="i in lastPage" :key="i" :value="i">
              Jump To Page {{ i }}
            </option>
          </select>
        </div>
        <div class="col-md-6">
          <paginate
            class="block-right"
            containerClass="pagination"
            pageLinkClass="page-link"
            pageClass="page-item"
            prev-text="Prev"
            next-text="Next"
            prev-link-class="page-link"
            next-link-class="page-link"
            :page-count="lastPage"
            :click-handler="paginationClickHandler"
            v-model="currentPage"
          >
          </paginate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "DeviceList",
  components: {},
  data() {
    return {
      deviceList: [],

      lastPage: 1,
      query: "",
      currentPage: 1,
    };
  },
  mounted() {
    this.isLoading(true);
    // if (this.can("list-registered-device")) {
    this.getDeviceList();
    // } else {
    //   this.$router.push({
    //     name: "Dashboard",
    //   });
    // }
  },
  methods: {
    paginationClickHandler(pageNum) {
      this.currentPage = pageNum;
      this.getDeviceList();
    },
    searchDevice() {
      this.currentPage = 1;
      this.getDeviceList();
    },
    ...mapMutations({
      isLoading: "loading",
    }),
    getDeviceList() {
      this.$http
        .get(`registered-device?page=${this.currentPage}&q=${this.query}`)
        .then((res) => {
          if (res.data.status == 1) {
            this.deviceList = res.data.data.data;
            this.lastPage = res.data.data.last_page;
            this.isLoading(false);
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
    },
    deleteDevice(id) {
      if (
        this.can("delete-registered-device") &&
        confirm("Are you sure you want to delete this device?")
      ) {
        this.$http.delete("registered-device/" + id).then((res) => {
          if (res.data.status == 1) {
            this.$notify({
              group: "notifications",
              title: "Device",
              type: "success",
              text: res.data.message,
            });
            this.getDeviceList();
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        });
      }
    },
  },
  watch: {
    currentPage: function () {
      this.getDeviceList();
    },
    onPageChange(page) {
      console.log(page);
      this.currentPage = page;
    },
  },
};
</script>
<style>
.block-right {
  float: right !important;
}
</style>
